import { CustomMaterialModule } from './custom-material/custom-material.module';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { CustomBootstrapModule } from './custom-bootstrap/custom-bootstrap.module';

import * as fromComponents from './components';
import * as fromUiElements from './ui-elements';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { MbscModule } from '@mobiscroll/angular'
import { TimeMaskDirective } from './directives/time-mask.directive';
import { NumberInputCheckDirective } from './directives/number-input-check.directive';
import { AutocompletePositionUpdateDirective } from './directives/autocomplete-position-update.directive';
import { InitialInputRoundNumberMaskDirective } from './directives/initial-input-round-number-mask.directive';
import { TogglePasswordDirective } from './directives/toggle-password.directive';
import { PreventDoubleClickDirective } from './directives/prevent-double-click.directive';
import { TelephoneInputDirective } from './directives/telephone-input.directive';
import { AngularEditorModule } from '@kolkov/angular-editor';

@NgModule({
  declarations: [...fromComponents.components, ...fromUiElements.uiElements, AutoFocusDirective, InitialInputRoundNumberMaskDirective, TimeMaskDirective, NumberInputCheckDirective, AutocompletePositionUpdateDirective, TogglePasswordDirective, PreventDoubleClickDirective, TelephoneInputDirective],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    MbscModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    CustomBootstrapModule,
    AngularEditorModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CustomMaterialModule,
    CustomBootstrapModule,
    TranslateModule,
    AutoFocusDirective,
    InitialInputRoundNumberMaskDirective,
    TimeMaskDirective,
    NumberInputCheckDirective,
    AutocompletePositionUpdateDirective,
    PreventDoubleClickDirective,
    TogglePasswordDirective,
    TelephoneInputDirective,
    AngularEditorModule,
    ...fromUiElements.uiElements,
    ...fromComponents.components
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        //   {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: AuthTokenInterceptor,
        //     multi: true
        //   },
        //   {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: HttpErrorInterceptor,
        //     multi: true
        //   }
      ]
    };
  }
}
